import { render, staticRenderFns } from "./TheMainLayout.vue?vue&type=template&id=2e0c8397&scoped=true&"
import script from "./TheMainLayout.vue?vue&type=script&lang=js&"
export * from "./TheMainLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheMainLayout.vue?vue&type=style&index=0&id=2e0c8397&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0c8397",
  null
  
)

export default component.exports